import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { User } from '../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private apiUrl = environment.apiUrl + environment.user;

  constructor(private http: HttpClient) { }


  getAll(module?: string): Observable<User[]> {
    let params = new HttpParams();
    if (module) params = params.set('module', module)
    return this.http.get<User[]>(`${this.apiUrl}/formatted`, { params });
  }

  getById(id: number): Observable<User> {

    return this.http.get<User>(`${this.apiUrl}/${id}/formatted`)

  }

  getByUsername(payload: any): Observable<User> {

    return this.http.post<User>(`${this.apiUrl}/search/formatted`, payload)

  }

  update(id: number, payload: any): Observable<User> {

    return this.http.put<User>(`${this.apiUrl}/${id}/formatted`, payload)

  }

  create(payload: any): Observable<User> {

    return this.http.post<User>(`${this.apiUrl}/formatted`, payload)

  }

}
